import { Component, OnInit } from '@angular/core';
import { ProblemIssue } from '../Models/problem-issue';
import { ProblemIssueType } from '../Models/problem-issue-type';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '../base.component';
import { ProblemService } from '../shared/services/problem.service';
import { MessageBox } from '../shared/message-box/message-box';


@Component({
  selector: 'problem-issue-dialog',
  templateUrl: './problem-issue-dialog.component.html',
  styleUrls: ['./problem-issue-dialog.component.scss'],
  providers: [ProblemService, MessageBox]
})
export class ProblemIssueDialogComponent extends BaseComponent implements OnInit {
  problemIssueTypes: ProblemIssueType[] = [];
  problemIssue: ProblemIssue = new ProblemIssue();

  constructor(public problemService: ProblemService,public dialog: MatDialog,
     public dialogRef: MatDialogRef<ProblemIssueDialogComponent>) {
    super();
   }

  ngOnInit() {

    // Need an get func for recieve problemIssueTypes : displaying the checkbox titles
    this.subscriptions.push(this.problemService.getProblemIssueTypes().subscribe(result => {
      if (result.successful) {
        this.problemIssueTypes = result.returnValue;
      } else {
        console.log("خطا در دریافت انواع دلایل عدم تایید");
      }
    }));
  
  }


  
  
    changNotConfirm(issueId: number, checked: boolean) { //for changing state of checkboxes
      if (checked) {
        this.problemIssue.issueIds.push(issueId);
      }
      else {
        let drop = this.problemIssue.issueIds.indexOf(issueId);
        this.problemIssue.issueIds.splice(drop, 1);
      }
  
    }
  
}
